var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPencil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/pencil") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDC99-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-336.000000, -503.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Filled",
    transform: "translate(48.000000, 279.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Row-5",
    transform: "translate(0.000000, 224.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Pencil",
    transform: "translate(288.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3941126,7.10287955 L20.4131615,9.08381775 C20.2111991,9.28577891 19.8846214,9.28577891 19.682659,9.08381775 L14.912907,4.31409671 C14.7109445,4.11213555 14.7109445,3.78556006 14.912907,3.58359889 L16.893858,1.6026607 C17.6974108,0.799113101 19.0037213,0.799113101 19.8115712,1.6026607 L22.3941126,4.18518533 C23.2019625,4.98873293 23.2019625,6.29503491 22.3941126,7.10287955 Z M13.2112657,5.2852291 L1.92714976,16.5692718 L1.0161701,21.7901827 C0.891554953,22.4948982 1.50603652,23.1050788 2.21075663,22.9847615 L7.43170138,22.0694907 L18.7158174,10.785448 C18.9177798,10.5834868 18.9177798,10.2569113 18.7158174,10.0549501 L13.9460654,5.2852291 C13.7398058,5.08326794 13.4132282,5.08326794 13.2112657,5.2852291 Z M4.7804068,19.2162522 L6.84300226,19.2162522 L6.84300226,20.7760799 L4.07138962,21.261646 L2.73499964,19.9252647 L3.22056899,17.1536701 L4.7804068,17.1536701 L4.7804068,19.2162522 Z",
    id: "Icon",
    fill: "#191C24"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPencil);
export default __webpack_public_path__ + "static/media/icon-pencil.5b94182a.svg";
export { ForwardRef as ReactComponent };